import React, { Component } from 'react';
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';

import $ from 'jquery';
import AppUtils from '../../../apputils';
import CategoryForm from './categories';
import { AddCategoryData } from '../../../models/category';



//import DateTimePicker from 'react-datetime-picker';

class addCategory extends Component {
    constructor() {
        super()
        this.state = {
          //  showButtonType: "Add Organizer",
          txtCategoryName:'',
          ddlCategoryStatus: "",
            sendData: false,
            
        }
        this.editDataObj = {}
        this.data = {}
    }

    HandleCategoryInput = (e) => {
        let val = e.target.value;
        let name = e.target.name;
        this.setState({ [name]: val });
        this.editDataObj[name] = val;
    }


   
   
   
   
    SaveCategoryEntryData = (e) => {
        //   alert('iiii' + JSON.stringify(e))
        //   alert(this.state.txtOrganizerName)
        this.data = {
            txtCategoryName: e.txtCategoryName,
            ddlCategoryStatus:e.ddlCategoryStatus
           
        }


        this.setState({
            sendData:true
        })
       
      

        console.log(this.data);
        
    }


    HandleAddCategoryDataSuccessResponse = (res) => {

        console.log(JSON.stringify(res));
        if (res !== false) {

            document.getElementById('spnSuccessMessageTitle').innerText = "Server Response - ";
            document.getElementById('spnSuccessMessage').innerText = res.data.addcategoryresponse.message.value;
        //    let that = this;
            $('#crmSuccessAlert').slideDown().slideUp(3000, function () {
              //  that.HideModal();
            })
  

        }
        else {
            document.getElementById('spnWarningMessageTitle').innerText = "Server Response - ";
            document.getElementById('spnWarningMessage').innerText = this.props.PnkStore.GetData('error').prettyMessage;
            
          //  let that = this;
            $('#crmWarningAlert').slideDown().slideUp(3000, function () {
               // that.HideModal();
            })

        }
        this.setState({ sendData: false });
    }



    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }


    render() {
        return (
            <div>
                <CategoryForm {...this.props} HandleRouting={this.HandleRouting}
                HandleCategoryInput={this.HandleCategoryInput} editDataObj={this.editDataObj}
                    mystate={this.state} 
                    SaveCategoryEntryData={this.SaveCategoryEntryData}
                    

                />
                {(this.state.sendData === true) ? AddCategoryData(this.props.PnkStore, this.data, this.HandleAddCategoryDataSuccessResponse) : ""
                }
               
            </div>
        )
    }
}

export const AddCategory = PnkConnect(addCategory, '');
